import { FC } from 'react'
import { AvatarProps, Avatar } from 'components/features/socialFeed/Avatar/Avatar'
import { FeedUserUid } from 'interfaces/feed'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { isFeedUserMemberSelector, feedUserSelector } from 'selectors/feedSelectors'
import { userImagesCollectionSelector } from 'selectors/userImagesSelectors'
import { getItemFromCollection } from 'helpers/normalizeHelpers'
import { UserImage } from 'interfaces/userImage'

type UserAvatarProps = Pick<AvatarProps, 'matchRatio' | 'preventDonut'> & {
  userUid: FeedUserUid
}

export const UserAvatar: FC<UserAvatarProps> = (props) => {
  const {
    matchRatio,
    userUid,
    preventDonut,
  } = props

  const isOwn = useStoreSelector((state) => isFeedUserMemberSelector(state, { userUid }))
  const feedUser = useStoreSelector((state) => feedUserSelector(state, { userUid }))
  const avatar = useStoreSelector((state) => {
    const userImages = userImagesCollectionSelector(state)

    return feedUser && feedUser.avatarId
      ? getItemFromCollection<UserImage, 'id'>(userImages, feedUser.avatarId)
      : null
  })

  if (!feedUser) {
    return null
  }

  return (
    <Avatar
      matchRatio={ matchRatio }
      isOwn={ !!isOwn }
      name={ feedUser.username }
      avatar={ avatar }
      preventDonut={ preventDonut }
    />
  )
}
